import React from "react";

function NewSearchSection({ toggleNewSearchSection }) {
  return (
    <div className="relative search-container">
        <h2 className="mt-8 text-xl sm:text-2xl font-bold mb-6 text-center text-gray-800">
          Voici votre URL et votre code QR !
        </h2>{" "}
        <button
          className="text-night font-semibold underline hover:text-lavender"
          onClick={toggleNewSearchSection}
        >
          Nouvelle recherche
        </button>
      </div>
  );
}

export default NewSearchSection;
